var render, staticRenderFns
import script from "./vue-signature-pad.vue?vue&type=script&lang=js&"
export * from "./vue-signature-pad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports